export const order = {
  ALL: 'Tutto',

  // Experience
  JOB: 'Lavori',

  // Publications
  COURSE: 'Corsi',
  EXAM: 'Esami',
  DEGREE: 'Lauree',

  // Projects
  WEB: 'Siti Web',
  MOBILE: 'App Mobili',
  PERSONAL_PROJECTS: 'Progetti Personali',

  // Certificates
  THESIS: 'Tesi',
  JOURNAL: 'Rivista',
  CONFERENCE: 'Conferenza',

  // Skills
  CURRENT: 'Utilizzo attualmente',
  PAST_FREQUENTLY: 'Utilizzavo frequentemente in passato',
  PAST_OCCASIONALLY: 'Conosco alcune nozioni',
};
